import { reducer } from './reducer';
import { ActionTypes } from './action-types';

const DocumentValidationState = {
  reducer,
  actionTypes: ActionTypes,
  reducerKey: 'documentValidation',
};

export { DocumentValidationState };
